// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-applyMessage":"jobSearchDetail-applyMessage","jobSearchDetail-applyMessage__historyLink":"jobSearchDetail-applyMessage__historyLink"};